import { ListCard, ListRow } from '../_ListCard'
import { useI18n } from '../_i18n'
import { useLocalePath } from '../_localePath'

// Tide + current station cards for the country/state/city pages, in the shared
// navy tile-card treatment. Renders only the cards that have stations (empty
// handling is left to the page).
export default function StationLists({ tideStations = [], currentStations = [] }) {
  const { t } = useI18n()
  const localePath = useLocalePath()
  return (
    <>
      {tideStations.length > 0 && (
        <ListCard title={t('tide_stations')}>
          {tideStations.map((s) => (
            <ListRow key={s.id} href={localePath(`/tide_stations/${s.id}`)} name={s.name} />
          ))}
        </ListCard>
      )}
      {currentStations.length > 0 && (
        <ListCard title={t('current_stations')}>
          {currentStations.map((s) => (
            <ListRow key={s.id} href={localePath(`/current_stations/${s.id}`)} name={s.name} />
          ))}
        </ListCard>
      )}
    </>
  )
}
